import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TextNoteDialogOptions } from './textnote-dialog';


@Component({
    selector: 'app-textnote-dialog',
    templateUrl: './textnote-dialog.component.html',
})
export class TextNoteDialogComponent {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    Note?: string;
    BottomLine?: string;

    constructor(
        private dialogRef: MatDialogRef<TextNoteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: TextNoteDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.OKText = opts.OKText || 'OK';
        self.CancelText = opts.CancelText || 'Cancel';
        self.Note = opts.Note || '';
        self.BottomLine = opts.BottomLine || '';
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(this.Note);
    }
}
